import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { PensionFormFields } from "web_myplann/Portfolio/Forms/PensionForm/PensionFormFields";
import { useCreatePensionForm } from "web_myplann/Portfolio/Forms/PensionForm/useCreatePensionForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

export const CreatePensionForm = () => {
	const { t } = useResource();
	const { form, onSubmit, isPending } = useCreatePensionForm();

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.AddShared.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
		>
			<PensionFormFields control={form.control} />
		</PortfolioFormShell>
	);
};
